import { DataQueryParams } from 'common/src/query-params/DataQueryParams';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import { getRequest } from 'portal/src/api/requestTypes';

export async function getBigQuery<T>(
  viewName: string,
  params: DataQueryParams,
): Promise<T> {
  return (await getRequest(
    API_BASE_PATHS.BIGQUERY + `/${viewName}`,
    formatQueryParams(params),
  )) as T;
}
